import React from 'react';
import { useSelector } from 'react-redux';
import Header from './Header';
import GuestHeader from './GuestHeader';

// Picks the logged-in or guest header for pages accessible to both (support, legal pages, etc.)
const SiteHeader = () => {
    const { token } = useSelector((state) => state.auth);
    return token ? <Header /> : <GuestHeader />;
};

export default SiteHeader;
